import React from 'react';
import './WindBannerLogo.css';

const VENTUS_LOGO_URL = '/ventus-logo-clean.png';

export default function WindBannerLogo({
  name = 'via-ventus',
  compact = false,
  light = false,
  subtitle = 'Knowledge Base'
}) {
  return (
    <div className={`v-windmark ${compact ? 'v-windmark--compact' : ''} ${light ? 'v-windmark--light' : ''}`}>
      <img className="v-windmark__icon" src={VENTUS_LOGO_URL} alt="via-ventus logo" />

      {!compact && (
        <div className="v-windmark__text">
          <strong className="v-windmark__name">{name}</strong>
          <span className="v-windmark__sub">{subtitle}</span>
        </div>
      )}
    </div>
  );
}
